<template>
  <div class="relative inline-flex items-center justify-center h-full">
    <img
      class="outline-none inline justify-center cursor-pointer object-scale-down h-full focus-visible:ring focus-visible:ring-blue-500/50"
      ref="imageRef"
      data-testid="viewer-content-image"
      @load="onImageLoad"
      @click="openModal()"
      @keyup.enter="openModal()"
      :src="props.src"
      :alt="alt"
      tabindex="0"
    />
    <TextSelectOverlay v-if="hasOcrData" :image-bounds="imageBounds" />
  </div>
</template>
<script setup lang="ts">
import { ref, computed, Ref } from 'vue';
import { usePhotoSwipe } from './../../composables/usePhotoSwipe';
import { useImageBounds } from './../../composables/useImageBounds';
import { TrackEvents, useTrack } from '@/composables/useTrack';
import { useViewerItemStore } from './../../store/useViewerItemStore';
import { useFeatures } from '@/composables/useFeatures';
import { useArtifactsStore } from '../../store/useArtifactsStore';
import TextSelectOverlay from '../ocr/TextSelectOverlay.vue';

const props = defineProps<{
  src: string;
  alt?: string;
}>();

const viewerItemStore = useViewerItemStore();
const { getItemFeature } = useFeatures();
const ocrFeatureEnabled = getItemFeature('image-ocr-enabled', false);
const artifactsStore = useArtifactsStore();
const hasOcrData = computed(() => artifactsStore.isOcrDone && artifactsStore.hasOcrData);

const { init, open } = usePhotoSwipe(props.src);
const imageRef: Ref<HTMLImageElement | null> = ref(null);
const { track } = useTrack();
const { imageBounds, updateImageBounds } = useImageBounds(imageRef, ocrFeatureEnabled);

// initialize lightbox after image is loaded - need width/height of the image
const onImageLoad = () => {
  const width = imageRef.value ? imageRef.value.naturalWidth : undefined;
  const height = imageRef.value ? imageRef.value.naturalHeight : undefined;

  init(width, height);
  updateImageBounds();
};

const openModal = () => {
  open();
  track(TrackEvents.VIEWER_ITEM_ZOOM_CLICK, { viewer: 'copernicus', hashid: viewerItemStore.item?.id });
};
</script>
<style lang="scss">
.pswp--custom-bg {
  --pswp-bg: rgb(56, 69, 90);
  --pswp-icon-color: #f1f5f9;
  --pswp-icon-color-secondary: #141c31;
  --pswp-icon-stroke-color: transparent;
}

.pswp__bg {
  background: rgb(56, 69, 90) !important;
}

.pswp__top-bar {
  .pswp__button {
    width: 50px;
    height: 50px;
    margin: 10px;
    padding: 0;
    border-radius: 8px;
    background-color: rgba(20, 28, 49, 0.4);
  }
  .pswp__button:hover {
    background-color: rgba(20, 28, 49, 1);
  }
  .pswp__icn {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
